import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { transformIntoQueryParamString } from '@old/utils/service';
import { CountrysideZonePayload, CountrysideZoneResponse } from './countryside-zone.types';

export async function listCountrysideZoneService(payload: CountrysideZonePayload) {
  const query = transformIntoQueryParamString(payload);

  const { response, data } = await BACKEND.get<CountrysideZoneResponse>(ENDPOINT.COUNTRYSIDES_ZONES, {
    query,
  });

  return {
    response,
    summary: data,
  };
}
